import ReactDOM from 'react-dom/client';
import { HashRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(<HelmetProvider>
  <HashRouter>
    <App />
  </HashRouter>
</HelmetProvider>);